import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const Permiso = ({ rol, permiso, handleSwitch }) => {
  return (
    <Form.Group>
      <Form.Check
        type="switch"
        id={permiso.id}
        className="m-0"
        label={permiso.permissionName}
        checked={rol.permisos[permiso.id] || false}
        onChange={handleSwitch}
      />
    </Form.Group>
  );
};

Permiso.propTypes = {
  rol: PropTypes.object.isRequired,
  permiso: PropTypes.object.isRequired,
  handleSwitch: PropTypes.func.isRequired
};

export default Permiso;
